// User journey and engagement analytics
import { trackEvent, setUserProperties } from './analytics';

// Account creation tracking
export const trackAccountCreated = (method, source = 'direct') => {
    trackEvent('account_created', {
        method, // 'email' or 'google'
        source, // 'marketing_site', 'direct', etc.
        timestamp: new Date().toISOString()
    });
};

// Onboarding tracking
export const trackOnboardingStep = (step, timeSpent = 0, additionalData = {}) => {
    trackEvent('onboarding_step_completed', {
        step, // 'language_selection', 'profile_creation', 'first_lesson'
        time_spent: timeSpent,
        ...additionalData
    });
};

export const trackOnboardingCompleted = (totalTime, language, ageGroup) => {
    trackEvent('onboarding_completed', {
        total_time: totalTime,
        language,
        age_group: ageGroup,
        timestamp: new Date().toISOString()
    });
};

// Anonymous to authenticated conversion
export const trackAnonymousConversion = (conversionMethod, timeToConvert, progressTransferred) => {
    trackEvent('user_converted_anonymous', {
        conversion_method: conversionMethod,
        time_to_convert: timeToConvert,
        progress_transferred: progressTransferred,
        timestamp: new Date().toISOString()
    });
};

// User engagement tracking
export const trackSessionStart = (sessionId, userType = 'anonymous') => {
    trackEvent('session_started', {
        session_id: sessionId,
        user_type: userType,
        timestamp: new Date().toISOString()
    });
};

export const trackSessionEnd = (sessionId, duration, pagesVisited, actionsTaken) => {
    trackEvent('session_ended', {
        session_id: sessionId,
        duration,
        pages_visited: pagesVisited,
        actions_taken: actionsTaken,
        timestamp: new Date().toISOString()
    });
};

// User properties setup
export const setUserAnalyticsProperties = (user, progress) => {
    const properties = {
        user_type: user?.isAnonymous ? 'anonymous' : 'authenticated',
        has_email: !!user?.email,
        signup_method: user?.providerData?.[0]?.providerId || 'email',
        trial_status: progress?.subscriptionStatus || 'trial',
        onboarding_complete: progress?.onboardingComplete || false,
        language_preference: progress?.profiles?.[progress?.lastActiveProfileId]?.currentLanguage || 'unknown',
        age_group: progress?.profiles?.[progress?.lastActiveProfileId]?.ageGroup || 'unknown'
    };
    
    setUserProperties(properties);
    return properties;
};

// Retention tracking
export const trackUserRetention = (daysSinceSignup, userType) => {
    trackEvent('user_retention_check', {
        days_since_signup: daysSinceSignup,
        user_type: userType,
        retention_milestone: daysSinceSignup === 1 ? '1_day' : 
                           daysSinceSignup === 7 ? '7_day' : 
                           daysSinceSignup === 30 ? '30_day' : 'other'
    });
};

export default {
    trackAccountCreated,
    trackOnboardingStep,
    trackOnboardingCompleted,
    trackAnonymousConversion,
    trackSessionStart,
    trackSessionEnd,
    setUserAnalyticsProperties,
    trackUserRetention
};


